import { Component, OnInit, Input } from '@angular/core';
import { DadosService } from '../../db/dados.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-forma-pagamento',
  templateUrl: './forma-pagamento.component.html',
  styleUrls: ['./forma-pagamento.component.scss']
})
export class FormaPagamentoComponent implements OnInit {

  constructor(
    private dados: DadosService,
    private router: Router) { }

  ngOnInit() {
  }


  @Input()
  get meiosPagamento() {
    return this.dados.meiosPagamento;
  }
  @Input()
  get total() {
    return this.dados.total;
  }

  pagar(item) {
    this.dados.carrinho.formaPagamento={nome:item.nome,operacao:item.operacao,parcelas:1,maxParcelas:item.maxParcelas};
    this.dados.salvar();
    this.router.navigate(['/enviar']);
  }

}
